// cities
export const AMSTERDAM = "AMSTERDAM";
export const NEW_YORK  = "NEW_YORK";
export const SAN_JOSE  = "SAN_JOSE";
export const SINGAPORE = "SINGAPORE";



// WEBPACK FOOTER //
// ./src/Constants.js